export type TermsContentVariantKey =
  | 'contentBrokerageClient'
  | 'contentBrokerageProspect'
  | 'contentRetirementClient'
  | 'contentRetirementProspect';

export function resolveTermsContentVariant(
  isIraAccount: boolean,
  isProspect: boolean,
): TermsContentVariantKey {
  if (isIraAccount) {
    return isProspect ? 'contentRetirementProspect' : 'contentRetirementClient';
  }
  return isProspect ? 'contentBrokerageProspect' : 'contentBrokerageClient';
}
